<template>
    <base-file-input
        v-model="model"
        v-validate="{
            required: true,
        }"
        input-id="utility"
        input-label="UTILITY BILL SCAN COPY"
        :placeholder="
            originalFileName || 'Select scan copy (JPG, PNG or TIFF file)'
        "
        drop-placeholder="Drop file here..."
        file-type="utility"
        accept="image/*"
        data-vv-name="utility bill scan copy"
        :class="{
            'is-invalid': errors.has('utility bill scan copy'),
        }"
        @update:originalFileName="updateOriginalFileName"
    ></base-file-input>
</template>

<script>
import IdentityDocument from './IdentityDocument'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: IdentityDocument, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    key: 'documentInfo.utility.fileName',
                    originalFileNameKey:
                        'documentInfo.utility.originalFileName',
                }
            },
            required: false,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
